// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-card {
  padding: 6px;
}

.mat-icon-button .mat-icon,
.mat-icon-button i {
  line-height: 23px;
}

.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 19px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}

.iconcolor {
  color: black;
}

.btnsize {
  width: 27px;
  height: 27px;
  padding: 0px;
}

.processor_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 7px;
  font-size: 12px !important;
  left: -3px;
}

.font_size_process {
  font-size: 12px !important;
}

.active_card {
  border-left: 4px solid #07a36e !important;
}

.failed_card {
  border-left: 4px solid #da606c !important;
}

.search_btn_agent {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
  line-height: 0 !important;
}

.displayName_ellipsis {
  max-width: 78%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agen_ellipsis {
  max-width: 93%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.arrow_source {
  width: 80%;
  height: 2px;
  background-color: grey;
  position: relative;
  margin: auto;
  margin-block: 6%;
}

.processor_id {
  color: black;
  width: 32%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top: 7px;
}

.btn_row {
  margin-top: -3px;
  margin-right: -16px;
}

.interface_feild {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 59%;
  position: relative;
  top: 6px;
}

.processor_feild {
  float: left;
  width: 72%;
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
  .processor_label {
    float: left;
    padding-right: 3%;
    position: relative;
    top: 8px;
  }
  .processor_id {
    width: 30%;
  }
  .btnsize {
    margin-inline: 15% !important;
  }
  .btn_row {
    width: 169%;
  }
  .interface_label {
    float: left;
  }
  .interface_feild {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 44%;
    position: relative;
    top: 0;
  }
}
@media screen and (min-width: 750px) and (max-width: 786px) {
  .processor_label {
    float: unset;
    padding-right: 0%;
    position: static;
    top: 8px;
  }
  .processor_feild {
    float: unset;
    width: 100%;
  }
  .search_btn_agent {
    background-color: #17a2b8;
    color: white;
    border: none;
    outline: none;
    padding-inline: 6%;
    margin-bottom: 4% !important;
    line-height: 0 !important;
  }
  .processor_id {
    width: 30%;
  }
  .btnsize {
    margin-inline: 15% !important;
  }
  .btn_row {
    width: 197%;
  }
  .interface_label {
    float: left;
  }
  .interface_feild {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 44%;
    position: relative;
    top: 0;
  }
}
::ng-deep.agentlistmodaledit .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/agents/agentlist/agentlist.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACE,YAAA;AAAF;;AAGA;;EAEE,iBAAA;AAAF;;AAEA;EACE,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,mCAAA;AACF;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,YAAA;AACJ;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,0BCtCS;EDuCT,UAAA;AACF;;AAEA;EACE,0BC3CS;AD4CX;;AAUE;EACE,yCAAA;AAPJ;;AAUA;EACE,yCAAA;AAPF;;AAUA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AAPF;;AAUE;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPJ;;AAUA;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAPF;;AAUA;EACE,YAAA;EACE,UAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;AAPJ;;AAUA;EACE,gBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;AAPF;;AAUA;EACE,WAAA;EACA,UAAA;AAPF;;AASA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EANF;EASA;IACE,UAAA;EAPF;EAUA;IACE,6BAAA;EARF;EAWA;IACE,WAAA;EATF;EAYA;IACE,WAAA;EAVF;EAaA;IACE,qBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,UAAA;IACA,kBAAA;IACA,MAAA;EAXF;AACF;AAgBA;EACE;IACE,YAAA;IACA,iBAAA;IACA,gBAAA;IACA,QAAA;EAdF;EAiBA;IACE,YAAA;IACA,WAAA;EAfF;EAkBA;IACE,yBAAA;IACA,YAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;IACA,4BAAA;IACA,yBAAA;EAhBF;EAmBA;IACE,UAAA;EAjBF;EAoBA;IACE,6BAAA;EAlBF;EAqBA;IACE,WAAA;EAnBF;EAsBA;IACE,WAAA;EApBF;EAuBA;IACE,qBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,UAAA;IACA,kBAAA;IACA,MAAA;EArBF;AACF;AAyBA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAvBF","sourcesContent":["@import \"../../../variables.scss\";\r\n.mat-card {\r\n  padding: 6px\r\n}\r\n\r\n.mat-icon-button .mat-icon,\r\n.mat-icon-button i {\r\n  line-height: 23px;\r\n}\r\n.material-icons {\r\n  font-family: 'Material Icons';\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  font-size: 19px;\r\n  line-height: 1;\r\n  letter-spacing: normal;\r\n  text-transform: none;\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  word-wrap: normal;\r\n  direction: ltr;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\n.iconcolor{\r\n    color: black;\r\n}\r\n\r\n.btnsize{\r\n    width: 27px;\r\n    height: 27px;\r\n    padding: 0px;\r\n}\r\n\r\n.processor_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 7px;\r\n  font-size: $fontsize;\r\n  left: -3px;\r\n}\r\n\r\n.font_size_process{\r\n  font-size: $fontsize;\r\n}\r\n\r\n// ::ng-deep.pipeSearch .autocomplete-container {\r\n//   height: 35px !important;\r\n//   .input-container input{\r\n//     height: 35px !important;\r\n//     padding-right: 13%;\r\n//   }\r\n//   }\r\n\r\n  .active_card{\r\n    border-left:  4px solid #07a36e !important;\r\n  }\r\n\r\n.failed_card {\r\n  border-left: 4px solid #da606c !important;\r\n}\r\n\r\n.search_btn_agent {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n  outline: none;\r\n  line-height: 0 !important;\r\n}\r\n\r\n  .displayName_ellipsis{\r\n    max-width: 78%;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.agen_ellipsis{\r\n  max-width: 93%;\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.arrow_source{\r\n  width: 80%;\r\n  height: 2px;\r\n  background-color: grey;\r\n  position: relative;\r\n  margin: auto;\r\n  margin-block: 6%;\r\n}\r\n\r\n.processor_id{\r\n  color: black;\r\n    width: 32%;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    position: relative;\r\n    top: 7px;\r\n}\r\n\r\n.btn_row {\r\n  margin-top: -3px;\r\n  margin-right: -16px;\r\n}\r\n\r\n.interface_feild {\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 59%;\r\n  position: relative;\r\n  top: 6px;\r\n}\r\n\r\n.processor_feild {\r\n  float: left;\r\n  width: 72%;\r\n}\r\n@media screen and (min-width: 900px) and (max-width: 1024px) {\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 3%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .processor_id {\r\n    width: 30%;\r\n  }\r\n\r\n  .btnsize {\r\n    margin-inline: 15% !important;\r\n  }\r\n\r\n  .btn_row {\r\n    width: 169%;\r\n  }\r\n\r\n  .interface_label {\r\n    float: left;\r\n  }\r\n\r\n  .interface_feild {\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: 44%;\r\n    position: relative;\r\n    top: 0;\r\n  }\r\n}\r\n\r\n\r\n\r\n@media screen and (min-width: 750px) and (max-width: 786px) {\r\n  .processor_label {\r\n    float: unset;\r\n    padding-right: 0%;\r\n    position: static;\r\n    top: 8px;\r\n  }\r\n\r\n  .processor_feild {\r\n    float: unset;\r\n    width: 100%;\r\n  }\r\n\r\n  .search_btn_agent {\r\n    background-color: #17a2b8;\r\n    color: white;\r\n    border: none;\r\n    outline: none;\r\n    padding-inline: 6%;\r\n    margin-bottom: 4% !important;\r\n    line-height: 0 !important;\r\n  }\r\n\r\n  .processor_id {\r\n    width: 30%;\r\n  }\r\n\r\n  .btnsize {\r\n    margin-inline: 15% !important;\r\n  }\r\n\r\n  .btn_row {\r\n    width: 197%;\r\n  }\r\n\r\n  .interface_label {\r\n    float: left;\r\n  }\r\n\r\n  .interface_feild {\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: 44%;\r\n    position: relative;\r\n    top: 0;\r\n  }\r\n}\r\n\r\n\r\n::ng-deep.agentlistmodaledit .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
